import { Plus } from 'lucide-react'
import { type ComponentProps } from 'react'

import { Button } from '#app/components/ui/button.tsx'
import { cn } from '#app/utils/misc.tsx'

type Props = Pick<
	ComponentProps<'button'>,
	'onClick' | 'children' | 'disabled' | 'className'
>

export function AddButton({ children, onClick, disabled, className }: Props) {
	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			onClick={onClick}
			disabled={disabled}
			className={cn('w-full gap-1 border-dashed py-4', className)}
		>
			<Plus className="h-3.5 w-3.5" />
			{children}
		</Button>
	)
}
